export default __webpack_public_path__ + "static/media/vg.799622e5.png";